import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import DeviceContext from "../../../../service/indentifyDevice";
import NavigationTag from "../../../../generic/navigationTag";
import DatePickerInt from "../../../orderBook/obContainer/obDatePickerInt";
import { ATransferHisComm, ATransferHisEqPayOut, AEqMaxPayout, ACommFundLimit } from "../../../../service/fundTransfer/fundTransferApiService";
import moment from "moment";
import { subDays, addDays } from "../../../../service/dateTimeService";
import { parsedToken } from "../../../../service/storageHelper";
import { ATransferHisEqPayin } from "../../../../service/fundTransfer/fundTransferApiService";
import { Idevice } from "../../../../types/device";
import FtHistoryTblPayInMob from "./ftHistoryTblPayInMob";
import FtHistoryTblPayInDesk from "./ftHistoryTblPayInDesk";
import FtHistoryTblPayOutMob from "./ftHistoryTblPayOutMob";
import FtHistoryTblPayOutDesk from "./ftHistoryTblPayOutDesk";
import Loader from "../../../../generic/loader";
import { jwtToken } from "../../../../types/genericTypes";
import { IcommLimits } from "../../../../types/components/fundTransfer/ftTypes";
import TocNoData from "../../../generic/tocNoData/tocNoData";
import { forwardRef, useImperativeHandle, Ref } from "react";

const handleDevice: Idevice = DeviceContext();

if (handleDevice.isDesktop) {
	require("../../../../../assets/scss/components/toc/fundTransfer/ftHistory/ftHistoryDesk.scss");
} else if (handleDevice.isMobile) {
	require("../../../../../assets/scss/components/toc/fundTransfer/ftHistory/ftHistoryMob.scss");
} else {
	require("../../../../../assets/scss/components/toc/fundTransfer/ftHistory/ftHistoryTab.scss");
}

export interface IFtHistoryWrapProps {
	match: any;
	ref?: any;
}

const FtHistoryWrap = forwardRef((props: IFtHistoryWrapProps, ref: Ref<{ getDates: (frmDt: Date, toDate: Date) => void }>) => {
	const [isFixed, setIsFixed] = React.useState<boolean>(false);

	const [toFrmDt, setToFrmDt] = React.useState<{ toDate: Date; frmDt: Date }>({
		toDate: addDays(new Date(), 0),
		frmDt: subDays(new Date(), 30)
	});

	const [eqUserLim, setEqUserLim] = React.useState<string>("");

	const [coUserLim, setCoUserLim] = React.useState<IcommLimits>({
		colVal: "",
		lmAvl: "",
		lrB: "",
		mrUzd: "",
		piAmt: "",
		poAmt: ""
	});

	const [payinHist, setPayinHist] = React.useState<Array<any>>([]); //payin
	const [payoutHist, setPayoutHist] = React.useState<Array<any>>([]); //payout
	const [loader, setLoader] = React.useState<boolean>(false); //payout
	const pToken: jwtToken | null = parsedToken();

	const accType = pToken && pToken.accType !== "COMEQ" ? pToken?.accType : props.match.params.asset.toUpperCase();

	const mode = props.match.params.funds;

	const tagList = [
		{ value: "added", display: "Added Funds", href: "added" },
		{ value: "withdrawn", display: "Withdrawn Funds", href: "withdrawn" }
	];

	useImperativeHandle(ref, () => ({
		getDates(frmDt: Date, toDate: Date) {
			setToFrmDt({ frmDt, toDate });
			getFundHistory(frmDt, toDate);
		}
	}));

	const getDates = (frmDt: Date, toDate: Date) => {
		setToFrmDt({ frmDt, toDate });
		getFundHistory(frmDt, toDate);
	};
	const commFundLimitRes = (res: any) => {
		if (res.data) {
			setCoUserLim(res.data.lmt);
		}
	};

	function maxpayoutCallback(res: any) {
		if (res.data) {
			if (res.data) {
				setEqUserLim(res.data.maxPytAmt);
			}
		}
	}

	const transferHisRes = (res: any) => {
		setLoader(false);

		if (res.data) {
			mode === "added" ? setPayinHist(res.data.trnSt) : setPayoutHist(res.data.trnSt);
		} else {
			setPayinHist([]);
			setPayoutHist([]);
		}
	};

	const getFundHistory = (frmDt: Date, toDate: Date) => {
		setPayinHist([]);
		setPayoutHist([]);
		setLoader(true);
		// const accType = pToken && pToken.accType !== "COMEQ" ? pToken?.accType : props.match.params.asset.toUpperCase();
		if (pToken) {
			switch (accType) {
				case "CO":
					// api call for commodity if
					// either account type is CO or
					// account type if COMEQ and Commodity is selected
					ATransferHisComm(transferHisRes, {
						rTyp: mode === "added" ? "PAYIN" : "PAYOUT",
						sDt: moment(new Date(frmDt)).format("MM/DD/YYYY"),
						eDt: moment(new Date(toDate)).format("MM/DD/YYYY")
					});
					break;
				case "EQ":
					// api call for equity if
					// either account type is EQ or
					// account type if COMEQ and Equity is selected
					if (mode === "added") {
						ATransferHisEqPayin(transferHisRes, {
							sDt: moment(new Date(frmDt)).format("MM/DD/YYYY"),
							eDt: moment(new Date(toDate)).format("MM/DD/YYYY")
						});
					} else {
						ATransferHisEqPayOut(transferHisRes, {
							sDt: moment(new Date(frmDt)).format("MM/DD/YYYY"),
							eDt: moment(new Date(toDate)).format("MM/DD/YYYY")
						});
					}
					break;
				default:
					break;
			}
		}
	};
	React.useEffect(() => {
		AEqMaxPayout(maxpayoutCallback);
		ACommFundLimit(commFundLimitRes);
	}, [props.match.params.asset]);

	React.useEffect(() => {
		getFundHistory(toFrmDt.frmDt, toFrmDt.toDate);
	}, [props.match.params.funds]);

	const onContainerScroll = (e: React.UIEvent<HTMLElement>) => {
		// console.dir((e.target as HTMLElement).scrollTop);
		// if scrolltop is greater than 78 then fix the header
		(e.target as HTMLElement).scrollTop > 60 ? !isFixed && setIsFixed(true) : isFixed && setIsFixed(false);
	};
	return (
		<div className={"ft_history" + (isFixed ? " ftScrollActive" : "")}>
			<div className="ft_history_header">
				{props.match.params.asset && (
					<div className="cash_wrap">
						<p className="cash_txt">Cash Available</p>
						<p className="cash_val">
							<span className="rupy">₹</span>
							{toINR(props.match.params.asset === "eq" ? eqUserLim : coUserLim.lmAvl, 2)}
						</p>
					</div>
				)}
			</div>

			<div className="but_container">
				<NavigationTag defaultValue={mode} tagList={tagList} onSelect={() => {}} />

				{!handleDevice.isMobile && <DatePickerInt plusDays={30} sendDates={getDates} toDateCt={0} />}
			</div>

			<div className="his_tbl_wrap" onScroll={onContainerScroll}>
				{(payinHist || payoutHist) && !loader ? (
					(payinHist.length && mode === "added") || (mode !== "added" && payoutHist.length) ? (
						mode === "added" ? (
							!handleDevice.isMobile ? (
								<FtHistoryTblPayInDesk data={payinHist} />
							) : (
								<FtHistoryTblPayInMob data={payinHist} />
							)
						) : (
							pToken &&
							(!handleDevice.isMobile ? (
								<FtHistoryTblPayOutDesk
									asset={accType}
									data={payoutHist}
									lim={(pToken.accType === "EQ" ? eqUserLim : coUserLim) || "0"}
								/>
							) : (
								<FtHistoryTblPayOutMob
									asset={accType}
									data={payoutHist}
									lim={(pToken.accType === "EQ" ? eqUserLim : coUserLim) || "0"}
								/>
							))
						)
					) : (
						<TocNoData data={[]} callBackMeth={() => {}} showClrBtn={false} />
					)
				) : (
					<div className="ft_Hist_loader">
						<Loader size={20} color="blue" />
					</div>
				)}
			</div>
		</div>
	);
});

export default FtHistoryWrap;
